import React, { useEffect } from "react";
import "./Intro.css";
import { ReactComponent as ProfileSVG } from "../../images/profile-icon.svg";
import AOS from "aos";
import "aos/dist/aos.css";

const Intro = () => {
  useEffect(() => {
    AOS.init({ duration: 3000 });
    AOS.refresh();
  }, []);

  return (
    <>
      <div className="intro-container">
        <div className="box-1" data-aos="fade-up">
          <h1 className="name-heading">Hey, this is Adithyavarun</h1>
          <div>
            <div className="p-boxes">
              <p className="subheadings-1">Full Stack Developer</p>
              <p className="subheadings">PHP Developer</p>
              <p className="subheadings">Freelance Developer</p>
              <p className="subheadings" style={{ color: "rgb(4, 87, 183)" }}>
                (2 years of experience)
              </p>
            </div>
          </div>
        </div>
        <div className="box-2">
          <ProfileSVG className="profile-icon" data-aos="fade-left" />
        </div>
      </div>
    </>
  );
};

export default Intro;
